import VerifyEmailResponse from '@/models/entities/api/authorization-resource/verify-email-response';
import {
  VERIFY_EMAIL_RESPONSE_TYPE,
  VerifyEmailResponseType,
} from '@/models/entities/api/authorization-resource/verify-email-response-type';
import VerifyEmailResponseEmail from '@/models/entities/api/authorization-resource/verify-email-response-email';
import VerifyEmailResponseNotRequired from '@/models/entities/api/authorization-resource/verify-email-response-not-required';
import VerifyEmailResponseDeleted from '@/models/entities/api/authorization-resource/verify-email-response-deleted';

interface VerifyEmailResponseMap {
  [VERIFY_EMAIL_RESPONSE_TYPE.VERIFICATION_EMAIL_SENT]: VerifyEmailResponseEmail;
  [VERIFY_EMAIL_RESPONSE_TYPE.NO_VERIFICATION_REQUIRED]: VerifyEmailResponseNotRequired;
  [VERIFY_EMAIL_RESPONSE_TYPE.SUCCESSFULLY_DELETED]: VerifyEmailResponseDeleted;
}

export type AnyVerifyEmailResponse = VerifyEmailResponseMap[VerifyEmailResponseType];

const CONSTRUCTOR_MAP: Record<
  VerifyEmailResponseType,
  (source: unknown) => AnyVerifyEmailResponse
> = {
  [VERIFY_EMAIL_RESPONSE_TYPE.VERIFICATION_EMAIL_SENT]: (source: unknown) =>
    new VerifyEmailResponseEmail(source),
  [VERIFY_EMAIL_RESPONSE_TYPE.NO_VERIFICATION_REQUIRED]: (source: unknown) =>
    new VerifyEmailResponseNotRequired(source),
  [VERIFY_EMAIL_RESPONSE_TYPE.SUCCESSFULLY_DELETED]: (source: unknown) =>
    new VerifyEmailResponseDeleted(source),
};

export function isEmail(response: AnyVerifyEmailResponse): response is VerifyEmailResponseEmail {
  return response.emailResponseType === VERIFY_EMAIL_RESPONSE_TYPE.VERIFICATION_EMAIL_SENT;
}

export function isNotRequired(
  response: AnyVerifyEmailResponse,
): response is VerifyEmailResponseNotRequired {
  return response.emailResponseType === VERIFY_EMAIL_RESPONSE_TYPE.NO_VERIFICATION_REQUIRED;
}

export function isDeleted(
  response: AnyVerifyEmailResponse,
): response is VerifyEmailResponseDeleted {
  return response.emailResponseType === VERIFY_EMAIL_RESPONSE_TYPE.SUCCESSFULLY_DELETED;
}

export function parseVerifyEmailResponse(source: unknown) {
  const verifyEmailResponse = new VerifyEmailResponse(source);

  return CONSTRUCTOR_MAP[verifyEmailResponse.parsedEmailResponseType](source);
}
